import { stripBreakpointPrefix } from '@yola/atomic-css-generator';

const matchesResponsiveToken = (token, className, breakpoint) => {
  const stripped = stripBreakpointPrefix(token);
  if (stripped !== className && !stripped.startsWith(`${className}-`)) return false;
  return breakpoint ? token.startsWith(`${breakpoint}:`) : stripped === token;
};

export default matchesResponsiveToken;
